<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/BudgetPlan/ApproveGroup'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-users-cog"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>ชื่อกลุ่มอนุมัติ :</label>
                  <input
                    v-model="searchGroupName"
                    type="text"
                    class="form-control"
                    placeholder="พิมพ์ชื่อกลุ่มอนุมัติที่ต้องการค้นหา"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'approveGroup_statusKey'"
                    :name="'approveGroup_statusKey'"
                    :select2-options="statusOptions"
                    v-model="searchStatus"
                    ref="approveGroup_statusKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  ค้นหา
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="goToCreate"
                >
                  <i class="fas fa-plus"></i> เพิ่มกลุ่มอนุมัติ
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="approveGroupTable"
              >
                <thead>
                  <tr>
                    <th class="all text-center" style="width: 8%;">ลำดับ</th>
                    <th class="all text-center" style="width: 35%;">ชื่อกลุ่มอนุมัติ</th>
                    <th class="all text-center" style="width: 12%;">จำนวนแผนก</th>
                    <th class="all text-center" style="width: 12%;">จำนวนผู้อนุมัติ</th>
                    <th class="all text-center" style="width: 13%;">สถานะ</th>
                    <th class="all text-center" style="width: 10%;">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-bs4");
require("datatables.net-responsive-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" class="btn btn-sm btn-success" @click.prevent="toggleStatus"> 
      <i class="fas fa-play"></i> เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    toggleStatus: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่...",
          });

          axios
            .put(`/Api/BudgetPlan/ApproveGroup/${this.data.id}/ToggleStatus`, {}, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function(response) {
              if (response.data.success) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              var errorMsg = error.response && error.response.data && error.response.data.message 
                ? error.response.data.message 
                : "เกิดข้อผิดพลาด";
              Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" class="btn btn-sm btn-danger" @click.prevent="toggleStatus">
      <i class="fas fa-pause"></i> ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    toggleStatus: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่...",
          });

          axios
            .put(`/Api/BudgetPlan/ApproveGroup/${this.data.id}/ToggleStatus`, {}, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function(response) {
              if (response.data.success) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              var errorMsg = error.response && error.response.data && error.response.data.message 
                ? error.response.data.message 
                : "เกิดข้อผิดพลาด";
              Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let ApproveGroupActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editApproveGroup" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูล">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteApproveGroup" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบข้อมูล">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    editApproveGroup: function () {
      router.push({ path: `/BudgetPlan/ApproveGroup/Edit/${this.data.id}` });
    },
    deleteApproveGroup: function () {
      let self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        type: "warning",
        html: "คุณต้องการลบกลุ่มอนุมัตินี้หรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/BudgetPlan/ApproveGroup/" + this.data.id + "/Delete")
            .then(function (response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("ผลลัพธ์", response.data.message, "warning");
              }
            })
            .catch(function (error) {
              Swal.fire("ผิดพลาด", error.response.data.message, "error");
            })
            .finally(function () {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
  props: ["data"],
});

export default {
  components: {
    select2,
    DatatableWarning,
  },
  data: function () {
    return {
      searchGroupName: "",
      searchStatus: "false",
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน" },
          { id: "true", text: "ไม่ใช้งาน" },
        ],
      },
      dataTable: null,
    };
  },
  methods: {
    formSubmit: function (e) {
      e.preventDefault();
      this.dataTable.ajax.reload();
    },
    formReset: function () {
      this.searchGroupName = "";
      // #98: รีเซ็ตเป็น default "ใช้งาน" (false = Active) แทน empty
      this.searchStatus = "false";
      $("#approveGroup_statusKey").val("false").trigger("change");
      this.dataTable.ajax.reload();
    },
    goToCreate: function () {
      router.push({ path: "/BudgetPlan/ApproveGroup/Create" });
    },
    reloadDataTable: function () {
      this.dataTable.ajax.reload();
    },
    initDataTable: function () {
      let self = this;
      self.dataTable = $("#approveGroupTable").DataTable({
        responsive: true,
        searchDelay: 500,
        processing: true,
        serverSide: true,
        searching: false,
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          processing:
            '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
          lengthMenu: "Display _MENU_",
        },
        ajax: {
          url: "/Api/BudgetPlan/ApproveGroup/Search",
          type: "POST",
          contentType: "application/json",
          headers: {
            Authorization: "Bearer " + self.$root.user.access_token,
          },
          data: function (d) {
            return JSON.stringify({
              draw: d.draw,
              start: d.start,
              length: d.length,
              groupName: self.searchGroupName,
              inActiveStatus: self.searchStatus,
            });
          },
          error: function (xhr, error, code) {
            console.log(xhr);
            console.log(code);
          },
        },
        columns: [
          {
            data: null,
            className: "text-center",
            orderable: false,
            width: "8%",
            render: function (data, type, row, meta) {
              return meta.row + meta.settings._iDisplayStart + 1;
            },
          },
          {
            data: "groupName",
            className: "text-left",
            width: "35%",
          },
          {
            data: "orgCount",
            className: "text-center",
            width: "12%",
            render: function (data) {
              return data || 0;
            },
          },
          {
            data: "approverCount",
            className: "text-center",
            width: "12%",
            render: function (data) {
              return data || 0;
            },
          },
          {
            data: null,
            className: "text-center",
            orderable: false,
            width: "13%",
            render: function (data) {
              return "<div class='actionsStatus'></div>";
            },
          },
          {
            data: null,
            responsivePriority: -1,
            orderable: false,
            className: "text-center",
            width: "10%",
            render: function (data, type, row) {
              return "<div class='actions'></div>";
            },
          },
        ],
      })
      .on("draw.dt", function () {
        $("#approveGroupTable .actionsStatus").each(function (i, el) {
          var $dt = self.dataTable;
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            // Mount StatusActions component based on status
            if (!data.inActiveStatus) {
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(el);
            } else {
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(el);
            }
          }
        });
        $("#approveGroupTable .actions").each(function (i, el) {
          var $dt = self.dataTable;
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new ApproveGroupActions({
              propsData: {
                data: data,
              },
            }).$mount(el);
          }
        });
      });
    },
  },
  mounted() {
    this.initDataTable();
    // Set default status to "ใช้งาน" (false = Active)
    $("#approveGroup_statusKey").val("false").trigger("change");
  },
  watch: {
    '$route.query.reload': function() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    }
  },
  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/ApproveGroupList.vue